import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { NewGasConnectionPage, NewGasConnectionPageProps } from "./NewGasConnectionPage";

export const EMPTY_PAGE_CONTENT: NewGasConnectionPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/gas/new-connection";

export const NewGasConnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<NewGasConnectionPageProps>("new_gas_connections_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <NewGasConnectionPage {...routeProps} {...content} />;
};
